import { useKratosSession } from "@saflib/ory-kratos-sdk";
import { useGetOrganization } from "@vendata/power-up-sdk";

export function useOnboardingLoader() {
  return {
    sessionQuery: useKratosSession(),
    organizationQuery: useGetOrganization(),
  };
}
